import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { IResponse } from "@app/lib/models/response.model";
import { AppConfiguration } from "@app/lib/services/app-config.service";
import { BaseHttpService } from "@app/lib/services/base-http.service";
import { map, Observable } from "rxjs";
import { ICaseItem, ICaseParty, ICasePartyParams, ICaseSearchRequestBody, ISearchRequestParams } from "../models/case-assignment.model";
import { IHPCaseData, IHpCaseDocumentType, IHPCaseSearchRequestBody } from "../models/hearing-process.model";
import { TAny } from "@app/lib/models/common.type";

@Injectable({
    providedIn: 'root'
})
export class HearingProcessService extends BaseHttpService {

    constructor(http: HttpClient, appConfig: AppConfiguration) {
        super(http, appConfig);
    }

    /**
     * Search Case By case information
     * @param reqBody 
     * @param queryParams 
     * @returns 
     */
    searchCaseNumber(reqBody: ICaseSearchRequestBody, queryParams: ISearchRequestParams): Observable<IResponse<ICaseItem[]>> {
        return this.post<IResponse<ICaseItem[]>, ICaseSearchRequestBody>('case/search/by/case-number.htm', reqBody, { params: { ...queryParams } });
    }

    getDocumenTypes() {
        return this.get<IResponse<IHpCaseDocumentType[]>>('hearing-process/doc-types.htm');
    }

    searchCaseDetails(reqBody: IHPCaseSearchRequestBody) {
        return this.post<IResponse<IHPCaseData[]>, IHPCaseSearchRequestBody>('hearing-process/documents/search.htm', reqBody)
            .pipe(map((res: IResponse<IHPCaseData[]>) => {
                const phaseIds = (res.data || []).map(item => item.casePhaseId);
                const latestPhase = Math.max(...phaseIds);
                return (res.data || []).find(item => item.casePhaseId === latestPhase) || null;
            }));
    }

    getPartyDetails(queryParams: ICasePartyParams) {
        return this.get<IResponse<ICaseParty[]>>('parties/by/case.htm', { params: { ...queryParams } })
    }

    getDocumentTypesByCaseNo(queryParams: TAny) {
        return this.get<IResponse<IHpCaseDocumentType[]>>('hearing-process/doc-types.htm', { params: { ...queryParams } });
    }

    getCasePhases(queryParams: TAny) {
        return this.get<IResponse<IHpCaseDocumentType[]>>('hearing-process/casephase/types/list.htm', { params: { ...queryParams } });
    }

    upsertDocument(reqBody: TAny) {
        return this.post<IResponse<TAny>, TAny>('hearing-process/documents/upsert.htm', reqBody);
    }

    uploadFile(formData: FormData, queryParams:{} = {}) {
        return this.post<IResponse<TAny>, TAny>('documents/uploadFile.htm', formData, {params: {...queryParams}});
    }

}